import React from 'react';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';

import { useRootStore } from '../stores/BridgeProvider';
import storageService from '../services/storage.service';

const App = observer(() => {
  const { authStore } = useRootStore();
  const { isAuthenticated } = authStore;
  const activeOrg = storageService.getItem('activeOrg');

  if (isAuthenticated) {
    if (activeOrg) {
      return <Redirect to="/dashboard" />;
    }
    return <Redirect to="/select-organization" />;
  }

  return <Redirect to="/login" />;
});

export default App;
